import { FileDown } from 'lucide-react';
import { Card } from '@siliconx/shared/ui/Card';
import { SectionLabel } from '@siliconx/shared/ui/SectionLabel';
import { apiDownload } from '../../lib/api';
import { DISCLOSURE_MAPPINGS } from './reportsCopy';

const REPORT_DOWNLOAD_PATH = '/api/client/export/carbon.csv';
const REPORT_FILENAME = 'fleet-carbon-export.csv';

/**
 * SIL-477 — Reports tab. SIL-459 register: GHG Protocol / CSRD ESRS E1 / CDP
 * rows are framed as export-ready EXTRACTS the customer files themselves —
 * never a claim that SiliconX filed, assured, or audited anything. All
 * three rows point at the SAME real export (the fleet carbon CSV — the
 * platform has no separate per-framework report machinery), because that
 * one file is what actually maps to each framework's datapoints.
 */
export function DisclosureMappingCard() {
  return (
    <Card padding="md" className="flex flex-col gap-3">
      <SectionLabel>Disclosure mapping</SectionLabel>
      <div className="flex flex-col divide-y divide-zinc-100 rounded-md border border-zinc-200">
        {DISCLOSURE_MAPPINGS.map((row) => (
          <div key={row.framework} className="flex items-start justify-between gap-3 p-3">
            <div className="flex flex-col gap-0.5">
              <span className="text-sm font-semibold text-zinc-800">{row.framework}</span>
              <span className="text-xs leading-relaxed text-zinc-500">{row.note}</span>
            </div>
            <button
              type="button"
              onClick={() => void apiDownload(REPORT_DOWNLOAD_PATH, REPORT_FILENAME)}
              className="inline-flex shrink-0 cursor-pointer items-center gap-1 rounded-md border border-zinc-300 bg-white px-2.5 py-1 text-xs font-medium text-zinc-700 hover:bg-zinc-50"
              aria-label={`Download the ${row.framework} export-ready extract`}
            >
              <FileDown className="size-3.5" />
              Download
            </button>
          </div>
        ))}
      </div>
      <p className="text-xs leading-relaxed text-zinc-400">
        Each row is the same asset-level export, mapped to that framework&apos;s datapoints — you file it
        yourself; SiliconX does not submit disclosures on your behalf.
      </p>
    </Card>
  );
}
